import { createLocation } from 'gyl-common/utils/url'
import { getStore } from '@/utils/dva'

import { checkRenderIsReady } from '@/utils/appRender'

// 请求必需数据
export const requestInitialData = async () => {
    const location = createLocation(window.location.href)
    const {
        query: { inviteId },
    } = location

    // 注意：只有app.js中oldRender执行完成，dvaStore才创建，所以这里需要等应用渲染
    // 原先这里临时处理用的是setTimeout，不保险
    await checkRenderIsReady()

    const store = getStore()

    await Promise.all([
        // 获取用户信息
        store.dispatch({
            type: 'user/fetchCurrent',
            inviteId,
        }),
        store.dispatch({
            type: 'menu/query',
        }),
        store.dispatch({
            type: 'menu/queryUserMenuWhiteList',
        }),
        store.dispatch({
            type: 'menu/queryBindShopTotal',
            payload: {},
        }),
        store.dispatch({ type: 'user/fetchUserPermissionPoints' }),
    ])
}

export let requestPromise = () => Promise.resolve()

export const startInit = () => {
    requestPromise = requestInitialData()
}

export default () => {
    return requestPromise
}
